import { valueOf } from 'shared';

export type ErrorContent = {
  title: string;
  japanese: string;
  english: string;
};

export type MaintenanceErrorContent = ErrorContent & {
  japaneseTerm?: string;
  englishTerm?: string;
};

export type ErrorResponseBody = {
  error: ErrorContent;
};

export type MaintenanceErrorResponseBody = {
  error: MaintenanceErrorContent;
};

export const ERROR_RESPONSE_STATUS = {
  badRequest: 400,
  unauthorized: 401,
  notFound: 404,
  serverError: 500,
  maintenance: 503,
  forbidden: 403,
} as const;

export type ErrorResponseStatus = valueOf<typeof ERROR_RESPONSE_STATUS>;
